module.exports = __webpack_public_path__ + "static/img/sanxingAL1.0c790d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/sanxingAL1.jpg
// module id = vvs0
// module chunks = 0